module.exports = __webpack_public_path__ + "img/infograph_10.c7c4cccc.png";